module.exports = __webpack_public_path__ + "static/media/bg.7b774a9b.png";